import { useEffect, useState } from "react";

const CustomerSupport = () =>{

    return(<> 

{/* <!-- Breadcumb Section Start --> */}
    <div className="breadcrumb-img">
     <img src="assets/img/banner/about-banner.jpg" alt="MeriPustak-About"/>
       
    </div>

    {/* <!-- About Section Start --> */}
    <section className="about-section fix section-padding">
        <div className="container">
            <div className="about-wrapper">
			
                <div className="row g-4 align-items-center">
                   
                    <div className="col-lg-6">
                        <div className="about-content">
                           <h3 className="mt-3 mt-md-0 wow fadeInUp mb-2" data-wow-delay=".5s">Customer Support:-</h3>
                            <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s"><b>Mobile Number:-</b> + 91 99905 33212</p>
                            <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s"><b>Toll Free:-</b> 1800 891 7183</p>
                            <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s"><b>Before Purchase:-</b> +91-11-4840 5001</p>
                            <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s"><b>Order Related Queries:-</b> +91-11-4840 5001</p>
                            <p className="mt-3  mt-md-0 wow fadeInUp" data-wow-delay=".5s"><b>Feedback and Suggestion:-</b> +91 11 4840 5001</p>
                            <p className="mt-3  mt-md-0 wow fadeInUp" data-wow-delay=".5s"><b>For any query and support via Email:</b></p>
                            <p className="mt-3  mt-md-0 wow fadeInUp" data-wow-delay=".5s">contactus@meripustak.com</p>
                            <p className="mt-3  mt-md-0 wow fadeInUp" data-wow-delay=".5s"><span className="sm-sz">*Support is available between 10 AM-5 PM (Monday to Friday)</span></p>
							
						
							
                        </div>
                    </div>
					 <div className="col-lg-6">
                        <div className="about-content">
                           <img src="assets/img/banner/cs.jpg" alt="MeriPustak-Support" className="cs-b"/>
							
                        </div>
                    </div>
                </div>
				
				
				
				
            </div>
        </div>
    </section>

     
    </>);

}

export default CustomerSupport;